import { render, staticRenderFns } from "./ExpansionPanelContent.vue?vue&type=template&id=0157f1ea&"
import script from "./ExpansionPanelContent.js?vue&type=script&lang=js&"
export * from "./ExpansionPanelContent.js?vue&type=script&lang=js&"
import style0 from "./ExpansionPanelContent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
